import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type EmergencyContact = {
    id: string;
    name: string;
    email: string;
    phone: string;
    groupNames: string; // to display in the table
    areaCode: string;
    groups: string[]; // to use in Edit page for assignment.
    orgAssigned: boolean;
};

type EmergencyContactsState = {
    contacts: EmergencyContact[];
    selectedContacts: EmergencyContact[];
    hasUnsavedChanges: boolean;
    showDiscardModal: boolean;
};

// remove this to empty once API integration is done
const initialState: EmergencyContactsState = {
    // These are full records to be used
    // in org and group views.
    selectedContacts: [],
    contacts: [],
    hasUnsavedChanges: false,
    showDiscardModal: false,
};

const emergencyContactsSlice = createSlice({
    name: 'emergencyContacts',
    initialState,
    reducers: {
        addEmergencyContact: (state, action: PayloadAction<EmergencyContact>) => {
            state.contacts.push(action.payload);
        },
        updateContacts: (state, action: PayloadAction<EmergencyContact[]>) => {
            state.contacts = action.payload;
        },
        updateSelectedContacts: (state, action: PayloadAction<EmergencyContact[]>) => {
            state.selectedContacts = action.payload;
        },
        updateContact: (state, action: PayloadAction<EmergencyContact>) => {
            state.contacts.forEach((item, index) => {
                if (item.id === action.payload.id) {
                    state.contacts[index] = action.payload;
                }
            });
        },
        deleteContacts(state, action: PayloadAction<string[]>) {
            state.contacts = state.contacts.filter((contact) => !action.payload.includes(contact.id));
        },
        setHasUnsavedChanges: (state, action: PayloadAction<boolean>) => {
            state.hasUnsavedChanges = action.payload;
        },
        setShowDiscardModal: (state, action: PayloadAction<boolean>) => {
            state.showDiscardModal = action.payload;
        },
    },
});

export const {
    addEmergencyContact,
    updateContacts,
    updateSelectedContacts,
    updateContact,
    deleteContacts,
    setHasUnsavedChanges,
    setShowDiscardModal,
} = emergencyContactsSlice.actions;
export default emergencyContactsSlice;
